import { Rail, RailStep } from '../ProgramSetup.styled';

export interface Step {
  id: string;
  label: string;
}

interface Props {
  steps: Step[];
  active: string;
  onGo: (id: string) => void;
}

export const StepRail = ({ steps, active, onGo }: Props) => (
  <Rail aria-label="Setup steps">
    {steps.map((step, index) => (
      <RailStep key={step.id} type="button" $on={step.id === active} onClick={() => onGo(step.id)}>
        <span className="n">{index + 1}</span>
        {step.label}
      </RailStep>
    ))}
  </Rail>
);
